import React, { useMemo } from "react";
import LanderRouter from "./landers/LanderRouter";
import { LanderConfigProvider } from "./commons/ConfigContext";
import {
  createLanderConfig,
  getApiUrl,
  getLanderSystem,
  parseLanderQueryParam,
} from "./commons/LanderConfig";
import { useFetch } from "./commons/useFetch";
import { getVisitorIdentifier } from "./commons/HelperFunctions";
import { System } from "./commons/Constants";
import { I18nProvider } from "./i18n/I18nProvider";

const errorPageStyle = `body {
  margin: auto;
  padding: 10px;
  background-color: #F3F7FC;
  font-family: 'Arial';
}`;

export const ParkingLander = () => {
  const queryConfig = parseLanderQueryParam(window.location.search);
  const extraHeaders = useMemo(
    () =>
      getLanderSystem(queryConfig) === System.PARKWEB
        ? { "X-Visitor-Id": getVisitorIdentifier() }
        : {},
    // queryConfig is derived from window.location.search (stable per page load)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const { body, err } = useFetch(
    getApiUrl(queryConfig),
    queryConfig,
    extraHeaders
  );

  // Fetch error - event already fired by useFetch
  if (err) {
    return (
      <>
        <style>{errorPageStyle}</style>
        <div id="errorMessage" />
      </>
    );
  }

  // Loading
  if (!body) {
    return null;
  }

  // Always create full config - routing logic decides what to use
  const landerConfig = createLanderConfig(body, queryConfig);

  return (
    <I18nProvider isI18n={ landerConfig.lander?.i18n }>
      <LanderConfigProvider
        landerConfig={ landerConfig }
        queryConfig={ queryConfig }
        targeted={ body.targeted }
      >
        <LanderRouter />
      </LanderConfigProvider>
    </I18nProvider>
  );
};
